import Box from "@mui/material/Box";

const History = () => {
	return <Box p={2}>Under Development !! </Box>;
};

export default History;
